// Appends the navigationEvent Id (encoded) in a parameter named 'navigationEventId'
// The intent is for this parameter to be retrieved by the backend
// for retreiving the FE navigationEventId
export function appendNavigationEventId(originalUrl: string, eventId: string) {
  let url = new URL(originalUrl);
  const encodedEventId = encodeURIComponent(eventId);
  url.searchParams.append("navigationEventId", encodedEventId);
  return url.toString();
}
